import {Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import { FileuploadService } from '../../service/http/fileupload.service';
import { forkJoin } from 'rxjs';
import { MessageDialogComponent } from "../../dialog/message-dialog/message-dialog.component";

interface Files {
  files: any
  rejected: boolean
}

@Component({
  selector: 'app-fileuploaddialog',
  templateUrl: './fileuploaddialog.component.html',
  styleUrls: ['./fileuploaddialog.component.css']
})
export class FileuploaddialogComponent implements OnInit {

  @ViewChild('file') file;
  public files: Set<File> = new Set();

  progress;
  // canBeClosed = true;
  primaryButtonText = 'Upload';
  showCancelButton = true;
  uploading = false;
  uploadSuccessful = false;
  currentPackageId;
  rejectedFiles: Files[] = [];
  rejectedFilesSelected: boolean = false;


  constructor(
      public dialogRef: MatDialogRef<FileuploaddialogComponent>,
      public uploadService: FileuploadService,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialog: MatDialog) {}

  ngOnInit() {
    this.currentPackageId = sessionStorage.getItem('currentPackageId');
  }

  addImages() {
      this.file.nativeElement.click();
  }

  onImagesAdded() {
      const files: { [key: string]: File } = this.file.nativeElement.files;

      for (let key in files) {
          if (!isNaN(parseInt(key))) {

              let generalFileTypeDef = this.data.acceptFileFormat.split("/").shift();
              let generalFileType = files[key].type.split("/").shift();
              let uploadedFileExtension = files[key].name.split('.').pop();

              // quick fix to allow non typical image formats 'eps' and 'pdf'
              if(generalFileType == generalFileTypeDef || uploadedFileExtension == 'eps' || uploadedFileExtension == 'pdf') {

                //to avoid duplicates, but there must be a smarter solution...
                let size = this.rejectedFiles.filter((entry) => {
                  return entry.files.name === files[key].name;
                });

                if(size.length == 0) {
                  this.rejectedFiles.push({files: files[key], rejected: false});
                  this.files.add(files[key]);
                }
              }
          }
      }
  }

  startUpload() {

        if(this.rejectedFilesSelected == true) {

          const dialogRef = this.dialog.open(MessageDialogComponent, {
            width: '250px',
            data: {
              // title: this.translate.instant('DIALOG.ACCEPT_DECLINE_DIALOG.TITLE'),
              // message: this.translate.instant('DIALOG.ACCEPT_DECLINE_DIALOG.MESSAGE')}});
              title: "REJECTED",
              message: "---"}});
        }

        // if everything was uploaded already, just close the dialog
        // if (this.uploadSuccessful) {
        //     return this.dialogRef.close();
        // }

        // set the component state to "uploading"
        this.uploading = true;

        // start the upload and save the progress map
        this.progress = this.uploadService.uploadImages(this.files, this.currentPackageId);

        // convert the progress map into an array
        let allProgressObservables = [];
        for (let key in this.progress) {
            allProgressObservables.push(this.progress[key].progress);
        }

        // Adjust the state variables

        // The OK-button should have the text "Finish" now
        // this.primaryButtonText = 'Finish';

        // // The dialog should not be closed while uploading
        // this.canBeClosed = false;
        this.dialogRef.disableClose = true;

        // Hide the cancel-button
        this.showCancelButton = false;

        // When all progress-observables are completed...
        forkJoin(allProgressObservables).subscribe(end => {
            // // ... the dialog can be closed again...
            // this.canBeClosed = true;
            this.dialogRef.disableClose = false;

            // ... the upload was successful...
            this.uploadSuccessful = true;

            // ... and the component is no longer uploading
            this.uploading = false;

            return this.dialogRef.close();
        });
  }

  closeDialog() {
      this.dialogRef.close();
  }
}
